import { c as _c } from "react/compiler-runtime";
import { LP_NODE_TYPES } from '@cc-shopping/contracts/credit-cards-page/landing-page/constants';
import { findStructuredContentByType } from '@cc-shopping/contracts/cross-site/structured-content/utils';
import type { StructuredContent, StructuredContentDocument } from '@cc-shopping/structured-content-renderer/hydration/types';
import { renderStructuredContent } from '@cc-shopping/structured-content-renderer/renderContext';
import { markNestedTypes } from '@cc-shopping/structured-content-renderer/utils';
import { Box, Typography } from '@mui/material';
import { Title } from 'src/features/ChaseLandingPages/ui/sections/Content/Benefits/BonusAndMainBenefit/components/Title';
import { TERMS_LINK_STYLES } from 'src/features/ChaseLandingPages/ui/termsLink';
export type CreditCardsLPOfferBlockProps = StructuredContentDocument<{
  disclaimer?: string;
  children?: StructuredContent;
}>;
export const CreditCardsLPOfferBlock = t0 => {
  const $ = _c(25);
  const {
    props
  } = t0;
  let t1;
  if ($[0] !== props.children) {
    t1 = type => findStructuredContentByType(props.children, type)?.props.children;
    $[0] = props.children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getChildrenOfType = t1;
  let T0;
  let T1;
  let disclaimer;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] !== getChildrenOfType || $[3] !== props.disclaimer) {
    const title = getChildrenOfType(LP_NODE_TYPES.offerBlockTitle);
    const body = getChildrenOfType(LP_NODE_TYPES.offerBlockBody);
    disclaimer = getChildrenOfType(LP_NODE_TYPES.offerBlockDisclaimer) ?? props.disclaimer;
    T1 = Box;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        display: "flex",
        flexDirection: "column",
        gap: 3,
        ...TERMS_LINK_STYLES
      };
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t5 = title && <Title>{renderStructuredContent([title].flat().map(markNestedTypes))}</Title>;
    T0 = Box;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        display: "flex",
        flexDirection: "column",
        color: "greens.dark",
        marginX: 2,
        gap: "10px"
      };
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    t3 = body && <Box sx={{
      fontSize: 18
    }}>{renderStructuredContent(body)}</Box>;
    $[2] = getChildrenOfType;
    $[3] = props.disclaimer;
    $[4] = T0;
    $[5] = T1;
    $[6] = disclaimer;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    T0 = $[4];
    T1 = $[5];
    disclaimer = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[13] !== disclaimer) {
    t6 = disclaimer && <Typography component="div" sx={{
      fontSize: 14,
      fontWeight: "lighter"
    }}>{renderStructuredContent(disclaimer)}</Typography>;
    $[13] = disclaimer;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== T0 || $[16] !== t2 || $[17] !== t3 || $[18] !== t6) {
    t7 = <T0 sx={t2}>{t3}{t6}</T0>;
    $[15] = T0;
    $[16] = t2;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== T1 || $[21] !== t4 || $[22] !== t5 || $[23] !== t7) {
    t8 = <T1 sx={t4}>{t5}{t7}</T1>;
    $[20] = T1;
    $[21] = t4;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};